<template lang="pug">
  v-flex(xs12 sm6 md4).card-content
    v-card.addon-card.mb-1
      v-card-title
        v-flex(xs2)
          .vertical-center
            slot(name="icon")
        v-flex(xs10)
          .body
            p.text-xs-center {{ properties.title }}
            p.text-xs-center {{ properties.usage }}
            v-progress-linear.usage(v-model="properties.percent" height="12" color="#5771e6")
</template>
<script>
export default {
  name: 'LimitUsage',
  props: {
    properties: Object,
  },
}
</script>
<style lang="scss" scoped>
.card-content {
  display: flex;
  flex-flow: row wrap;
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }


  .addon-card {
    padding-bottom: -10px;
    width: 93%;
    border-radius: 5px;
    border: 1px solid rgba(204, 204, 204, 0.91);
    background-color: #f8f8f8;
  }

  .v-card__title {
    align-items: flex-end;
  }

  .body {
    line-height: 20px;

    p {
      margin: 0px;
    }

    .usage {
      margin-top: 2px;
      margin-bottom: 2px;
    }
  }
}
</style>
